import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../../../../../@core/backend/common/api/http.service';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { VentilatorPriceSettings } from '../../interface/master/Ventilator-Price-Settings';

@Injectable()
export class VentilatorPriceSettingsAPI {


  constructor(private api: HttpService) { }

  list(url: string, data: any): Observable<any[]> {   
    let queryParams = new HttpParams()
    .set('tenantId', data.tenantId.toString())
    .set('branchId', data.branchId.toString());
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}, params: queryParams});
  }

  add(url:string, data: VentilatorPriceSettings):Observable<VentilatorPriceSettings>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directPost( url, data, header);
  }

  update(url:string, data: VentilatorPriceSettings):Observable<any>{
    let queryParams = new HttpParams()
    .set('id', data.id.toString());
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params: queryParams});
  }

}
